import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environments'
import { loginRequest } from '../interfaces/request/loginRequest.interface';
import { loginResponse } from '../interfaces/response/loginResponse.interface';
import { UserLogin } from '../interfaces/userLogin.interface';
import { otpResponse } from '../interfaces/response/otpResponse.interface';
import { otpRequest } from '../interfaces/request/otpRequest.interface';
import { epsResponse } from '../interfaces/response/epsResponse.interface';
import { singUpRequest } from '../interfaces/request/singupRequest.interface';
import { singUpResponse } from '../interfaces/response/singupResponse.interface';
import { infoCompanyResponse } from '../interfaces/response/infoCompanyResponse.interface';
import { HttpService } from '../core/http.service';
import { infoCredentialResponse } from '../interfaces/response/infoCredentialResponse';
import * as CryptoJS from 'crypto-js';
import { CryptoUtilService } from '../services/crypto-util.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { Chat, Message } from '../distributor/components/whatsapp/whatsapp.component';
import { Contador } from '../logistica/components/menu-logistica/menu-logistica.component';
import { firstValueFrom } from 'rxjs';
///////////// Paciente General info

export interface GestionPosterior {
  direccionResidencia: string;
  barrio: string;
  ciudad: string;
  telefono: string;
  email: string;
  nombreAcudiente: string;
  tipoIdAcudiente: string;
  noIdAcudiente: string;
  parentesco: string;
  id: string;
  autorizacion: string;
  dateSave: string;
  fechaRecibido: string;
  fechaReporteEpsaInphapro: string;
  fechaVigenciaDesde: string;
  fechaVigenciaHasta: string;
  idAutoInterno: string;
  idEstado: string;
  tipoEntrega: string;
  updateDate: string;
  fechaInt: number;
  funcionarioRadicacion: string;
  partner: string;
  idEPS: string;
  cohorte: string;
  eps: string;
  lote: string;
  laboratorio: string;
  soporteRemision: string;
  soporteFacturacion: string;
  encargadoEntrega: string;
  nota: string;
  codMedicamnetoEPS: string;
  nombrePaciente: string;
  tipoDocumentoPaciente: string;
  nDocumentoPaciente: string;
  nombreMedicamento: string;
  cantidadMinimaDispersar: string;
  ciudadEntrega: string;
  regimen: string;
  fechaDespacho: string;
  notificacion: number;
  nPrescripcion: string;
  preAutorizacion: string;
  hospital: string;
  contactoDespacho: string;
  telefonoDespacho: string;
  noRemision: string;
  dateHastaInt: number;
  dateDesdeInt: number;
  tipoServicio: string;
}

export interface DataPaciente {
  numeroDocumento: string;
  apellidosPaciente: string;
  barrio: string;
  correo: string;
  departamento: string;
  direccion: string;
  municipio: string;
  nombresPaciente: string;
  telefono: string;
  tipoId: string;
  fechaInt: number;
  fechaReporte: string;
  partner: string;
}
export interface eventoAdverso {
  idCaso: string;
  nombres: string;
  apellidos: string;
  tipoId: string;
  numeroId: string;
  sexo: string;
  fechaNacimiento: string;
  medicamento: string;
  noLote: string;
  fechaVencimiento: string;
  channel: string;
  descripcionEvento: string;
  status?: string;
  respuesta?: string;
}

export interface Medicamento {
  cod: string;
  codLab?: string;
  medicamento: string;
  active: string;
  fechaInt: number;
  fechaReporte: string;
  cohorte: string;
  descripcion: string;
  rango1?: string;
  rango2: string;
  rango3: string;
  presentacion: string;
  laboratorio: string;
  tipoTec: string;
  registroSanitario: string;
  eps: string;
  marca: string;
  codNeps: string;
  auxiliar: string;
  encargadoEPSSA?: string;
  encargadoEPSSAEPS?: string;
  atc?: string;
  tipoCodigo?: string;
}

export interface Tramite {
  autorizacion: string
  idHistorial: string;
  nombreMedicamento: string;
  semaforo: number;
  fechaEntrega: string;
  idEstado: string;
}
export interface Preguntas {
  active: string
  cod: string
  pregunta: string
  respuesta: string

}

export interface RootObject {
  gestionPosterio: GestionPosterior[];
  dataPaciente: DataPaciente;
  medicamentos: Medicamento[];
  tramites: Tramite[];
  urlValidar: string;
  preguntas: Preguntas[];

}



///////////// Fin interfaz paciente
export interface Eps {
  id: string;
  description: string;
  partnerName: string;
  active: number;
  nameEPS: string;
  email: string;
  nit: string;
}

interface Convenio {
  id: number;
  name: string;
  active: number;
}

export interface Estado {
  id: string;
  codigoColor: string;
  estado: string;
  active: number;
}
interface Medicamentos {
  active: string;
  cod: string;
  medicamento: string;
}

export interface Ips {
  id: string;
  active: number;
  barrio: string;
  departamento: string;
  direccion: string;
  municipio: string;
  nit: string;
  personaContacto: string;
  razonSocial: string;
  telefono: string;
  tipoDocumento: string;
  sucursal: [];
}
export interface Almacen {
  active: number;
  nit: string;
  razonSocial: string;
  sucursal: Sucursal[];
}
export interface Sucursal {
  active: number,
  'Persona de contacto': string,
  NombreSucursal: string,
  id: string,
  Barrio?: string;
  Departamento?: string;
  Direccion?: string;
  Municipio?: string;
  Telefono?: string;
}
export interface TipoUsuario {
  active: number
  id: string
  nombre: string
}
export interface TipoRecaudo {
  active: string
  concepto: string
  id: string
}

export interface Laboratorio {
  active: string
  id: string
  nameLaboratorio: string
}

export interface Auditoria {
  active: string
  descripcion: string
  id: string
}

export interface Data {
  almacenes: Almacen[]
  auditoria: Auditoria[]
  eps: Eps[];
  convenios: Convenio[];
  estados: Estado[];
  medicamentos: Medicamento[];
  ipsS: Ips[];
  tipoUsuario: TipoUsuario[];
  tipoRecaudo: TipoRecaudo[];
  labotorios: Laboratorio[];
  portalVitales: Eps[];
}

const variableInicial: Data = {
  almacenes: [],
  auditoria: [],
  eps: [],
  convenios: [],
  estados: [],
  medicamentos: [],
  ipsS: [],
  tipoUsuario: [],
  tipoRecaudo: [],
  labotorios: [],
  portalVitales: []
};
export interface ContadorEstados {
  id: number;
  name: string;
  estado: number;
  nuevo: number;
  color: string
}
export interface UnidadMedida {
  active: string;
  descripcion: string;
  nombre: string;
  id: string;
}
export interface ViaAdministracion {
  active: string;
  id: string;
  nombre: string;
}
export interface UnidadDispensacion {
  active: string;
  id: string;
  nombre: string;
}
export interface CategoriaMedicamento {
  codCategoria: string;
  active: string;
  nombreCategoria: string;
}

export interface FormaFarmaceutica {
  codigo: string;
  active: string;
  nombre: string;
}

export interface CodDiagnostico {
  cod: string;
  active: string;
  descripcion: string;
}

export interface UnidadMinDispensa {
  cod: string;
  active: string;
  nombre: string;
}

export interface PortalAdmingeneral {
  tiposMedicamentos: CategoriaMedicamento[];
  formaFarmaceutica: FormaFarmaceutica[];
  codDiagnostico: CodDiagnostico[];
  unidadMinDispensa: UnidadMinDispensa[]
}

export interface Cities {
  cod: string
  ciudad: string
  departamento: string
  active: string
}

export interface CountEstadoEps {
  count: number
  id: string
  name: string
}




/////////////// CONSTANTES UWU \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

const listCities: Cities[] = []

const portalAdminGeneral: PortalAdmingeneral = {
  tiposMedicamentos: [],
  formaFarmaceutica: [],
  codDiagnostico: [],
  unidadMinDispensa: []
}

const countEstadoEps: CountEstadoEps[] = []



const patientsGeneralInfo: RootObject = {
  gestionPosterio: [],
  dataPaciente: {
    numeroDocumento: '',
    apellidosPaciente: '',
    barrio: '',
    correo: '',
    departamento: '',
    direccion: '',
    municipio: '',
    nombresPaciente: '',
    telefono: '',
    tipoId: '',
    fechaInt: 0,
    fechaReporte: '',
    partner: '',
  },
  medicamentos: [],
  tramites: [],
  preguntas: [],
  urlValidar: ''
}


const contadorEstados: ContadorEstados[] = [
  {
    id: 0,
    name: '',
    estado: 0,
    nuevo: 0,
    color: ''
  }
];
const logisticaEstados: Contador[] = [
  {
    id: 0,
    name: '',
    estado: 0,
  }
];
const userLogin: UserLogin = {
  administrador: 0,
  code: '',
  configRol: {
    rol: '',
    mensaje: '',
    color: '',
    botones: '',
    principal: '',
    principal_hover: '',
    principal_text_hover: '',
    texto: '',
    principal_title: '',
    color_box: '',
    color_text_box: '',
    branch_menu: '',
    branch_menu_hover: '',
    branch_menu_text_hover: ''
  },
  menu: [],
  name: '',
  rol: '',
  rango: 0,
  status: '',
  token: '',
  numberId: '',
  ruta: '',
  rangoVitales: '',
  statusRechazar: ''
}

const userSingUp: singUpRequest = {
  action: '',
  email: '',
  password: '',
  phoneNumber: '',
  numberId: '',
  otp: '',
  name: '',
  typeIdentification: '',
  lastName: '',
  EPS: '',
  idEPS: '',
  cognitoId: '',
  habeasData: ''
}

const infoCompany: infoCompanyResponse = {
  code: '',
  rol: '',
  token: ''
}

const infoCredential: infoCredentialResponse = {
  email: '',
  rol: '',
  partner: '',
  eps: '',
  phoneNumber: '',
  name: '',
  lastName: '',
  validationDoc: '',
}



@Injectable({
  providedIn: 'root'
})


export class SharedServices {

  tabIndex: number = 0;
  medicamentoLab: any = []
  typepos = 'PBS'
  typenopos = 'NOPBS'
  medicamentoSource: any[] = []
  medicamentoRepo: any[] = []
  dataFilterMedicamento: any = []
  iumOpcionesIumMedicamentos: any = []
  dataIntegration: any
  chatWhat!: Chat

  private selectedMedicamento = new BehaviorSubject<any>(null);
  selectedMedicamento$ = this.selectedMedicamento.asObservable();

  private selectedLab = new BehaviorSubject<any>(null);
  selectedLab$ = this.selectedLab.asObservable();

  private selectedCaso = new BehaviorSubject<any>(null);
  selectedCaso$ = this.selectedCaso.asObservable();

  private selectedPatient = new BehaviorSubject<any>(null);
  selectedPatient$ = this.selectedPatient.asObservable();

  private selectedUsuario = new BehaviorSubject<any>(null);
  selectedUsuario$ = this.selectedUsuario.asObservable();

  private _usersingup = new BehaviorSubject<singUpRequest>(userSingUp);


  public get userSingUp(): singUpRequest {
    return this._usersingup.getValue();
  }

  public set userSingUp(v: singUpRequest) {
    this._usersingup.next(v);
  }

  private _userLoggin = new BehaviorSubject<UserLogin>(userLogin);

  public userLogin$ = this._userLoggin.asObservable();


  public get userLogin(): UserLogin {
    return this._userLoggin.getValue();
  }

  public set userLogin(value: UserLogin) {
    this._userLoggin.next(value);
  }

  private _patients_general_info = new BehaviorSubject<RootObject>(patientsGeneralInfo);

  public patients_general_info$ = this._userLoggin.asObservable();


  public get patients_general_info(): RootObject {
    return this._patients_general_info.getValue();
  }

  public set patients_general_info(value: RootObject) {
    this._patients_general_info.next(value);
  }


  private _infoCompany = new BehaviorSubject<infoCompanyResponse>(infoCompany);

  public infoCompany$ = this._infoCompany.asObservable();

  public get infoCompany(): infoCompanyResponse {
    return this._infoCompany.getValue();
  }

  public set infoCompany(value: infoCompanyResponse) {
    this._infoCompany.next(value);
  }

  private _infoCredential = new BehaviorSubject<infoCredentialResponse>(infoCredential);

  public get infoCredential(): infoCredentialResponse {
    return this._infoCredential.getValue();
  }

  public set infoCredential(v: infoCredentialResponse) {
    this._infoCredential.next(v);
  }

  private _generalinformation = new BehaviorSubject<Data>(variableInicial);

  public get generalinformation(): Data {
    return this._generalinformation.getValue();
  }

  public set generalinformation(v: Data) {
    this._generalinformation.next(v);
  }

  private _generalPortalAdmin = new BehaviorSubject<PortalAdmingeneral>(portalAdminGeneral);

  public get generalPortalAdmin(): PortalAdmingeneral {
    return this._generalPortalAdmin.getValue();
  }

  public set generalPortalAdmin(v: PortalAdmingeneral) {
    this._generalPortalAdmin.next(v);
  }

  private _cities = new BehaviorSubject<Cities[]>(listCities);

  public get cities(): Cities[] {
    return this._cities.getValue();
  }

  public set cities(v: Cities[]) {
    this._cities.next(v);
  }
  private _logisticaEstados = new BehaviorSubject<Contador[]>(logisticaEstados);

  public logisticaEstados$ = this._logisticaEstados.asObservable();

  public get logisticaEstados(): Contador[] {
    return this._logisticaEstados.getValue();
  }

  public set logisticaEstados(value: Contador[]) {
    this._logisticaEstados.next(value);
  }

  private _contadorEstados = new BehaviorSubject<ContadorEstados[]>(contadorEstados);

  public contadorEstados$ = this._contadorEstados.asObservable();

  public get contadorEstados(): ContadorEstados[] {
    return this._contadorEstados.getValue();
  }

  public set contadorEstados(value: ContadorEstados[]) {
    this._contadorEstados.next(value);
  }
  private _contadorEstadosVitales = new BehaviorSubject<ContadorEstados[]>(contadorEstados);
  public contadorEstadosVitales$ = this._contadorEstadosVitales.asObservable();


  public get estadosVitales(): ContadorEstados[] {
    return this._contadorEstadosVitales.getValue();
  }

  public set estadosVitales(value: ContadorEstados[]) {
    this._contadorEstadosVitales.next(value);
  }

  private _countEstadoEps = new BehaviorSubject<CountEstadoEps[]>(countEstadoEps);

  public countEstadoEps$ = this._countEstadoEps.asObservable();

  public get countEstadoEps(): CountEstadoEps[] {
    return this._countEstadoEps.getValue();
  }

  public set countEstadoEps(value: CountEstadoEps[]) {
    this._countEstadoEps.next(value);
  }



  private selectionState = new BehaviorSubject<boolean>(false);
  selectionState$ = this.selectionState.asObservable();

  private changeBucket = new BehaviorSubject<boolean>(false);
  changeBucket$ = this.changeBucket.asObservable();

  private selectedValues = new BehaviorSubject<{ eps: any; convenio: any }>({ eps: null, convenio: null });
  selectedValues$ = this.selectedValues.asObservable();

  apiUrl = environment.apiUrl
  apiUrlCum = 'https://enlinea.invima.gov.co/rs/cum/ins_cum.jsp';

  httpOptions = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
  };

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private crypto: CryptoUtilService

  ) { }

  setMedicamento(data: any) {
    this.selectedMedicamento.next(data);
  }

  setLabs(data: any) {
    this.selectedLab.next(data);
  }

  clearMedicamento() {
    this.selectedMedicamento.next(null);
  }

  setCaso(data: any) {
    this.selectedCaso.next(data);
  }

  clearCaso() {
    this.selectedCaso.next(null);
  }

  setPatient(data: any) {
    this.selectedPatient.next(data);
  }

  clearPatient() {
    this.selectedPatient.next(null);
  }

  setUser(data: any) {
    this.selectedUsuario.next(data);
  }

  clearUser() {
    this.selectedUsuario.next(null);
  }

  applyTheme(colors: any) {
    Object.keys(colors).forEach(key => {
      document.documentElement.style.setProperty(`--color-${key}`, colors[key]);
    });
  }

  selectionChanged(state: boolean, valueNopos?: boolean) {

    this.selectionState.next(state);
  }

  bucketNameChange(change: boolean) {
    this.changeBucket.next(change);
  }

  updateSelectedValues(eps: any, convenio: any) {
    this.selectedValues.next({ eps, convenio });
  }

  downloadCSV(data: any[], columns: string[], filename: string = 'datos.csv') {
    if (!data || !data.length) {
      console.warn('No hay datos para exportar.');
      return;
    }

    const separator = ',';
    const headers = columns.join(separator);

    const csvRows = data.map(row => {
      return columns.map(col => {
        const val = row[col] ?? '';
        // Escape comillas dobles y comas si es necesario
        return `"${val.toString().replace(/"/g, '""')}"`;
      }).join(separator);
    });

    const csvContent = [headers, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', filename);
    link.click();
    URL.revokeObjectURL(url);
  }

  //   downloadExcel(data: any[], columns: string[], filename: string = 'datos.xlsx') {
  //   if (!data || !data.length) {
  //     console.warn('No hay datos para exportar.');
  //     return;
  //   }

  //   // Filtrar las columnas deseadas
  //   const filteredData = data.map(row => {
  //     const newRow: any = {};
  //     columns.forEach(col => {
  //       newRow[col] = row[col] ?? '';
  //     });
  //     return newRow;
  //   });

  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
  //   const workbook: XLSX.WorkBook = {
  //     Sheets: { 'Hoja1': worksheet },
  //     SheetNames: ['Hoja1']
  //   };

  //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  //   FileSaver.saveAs(blob, filename);
  // }

  downloadExcel(data: any[], columns: string[], filename: string = 'datos.xlsx') {
    if (!data || !data.length) {
      console.warn('No hay datos para exportar.');
      return;
    }

    const filteredData = data.map(row => {
      const newRow: any = {};
      const rowKeys = Object.keys(row);

      columns.forEach((col: any) => {
        const colKey = typeof col === 'string' ? col : col.key;

        const matchedKey = rowKeys.find((key: string) => key.toLowerCase() === colKey.toLowerCase());

        newRow[colKey] = matchedKey ? row[matchedKey] : '';
      });

      return newRow;
    });


    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Hoja1': worksheet },
      SheetNames: ['Hoja1']
    };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, filename);
  }
  setAuthorizationData(data: object): Observable<any> {
    // return this.http.post<any>(
    //   `${this.apiUrl}/chatbot`,
    //   data,
    //   this.httpOptions
    // );
    return this.httpService.post<any>('chatbot', data);
  }

  getDataExcel(data: any): Observable<any> {
    return this.httpService.post<any>('exportData', data);
  }

  createPdf(data: object): Observable<any> {
    return this.httpService.post<any>('generarpdf', data);
  }

  postPortal(data: any): Observable<any> {
    return this.httpService.post<any>('portal', data);
  }

  postIntegracionSanitas(data: any): Observable<any> {
    return this.httpService.post<any>('IntegracionSanitas', data);
  }

  postWhatsapp(data: any): Observable<any> {
    return this.httpService.post<any>('portalWhatsapp', data);
  }

  postRegisterUser(data: any): Observable<any> {
    return this.httpService.post<any>('registerUser', data);
  }

  postPortalAdmin(data: any): Observable<any> {
    return this.httpService.post<any>('portalAdmin', data);
  }
  postElementosRips(data: any): Observable<any> {
    return this.httpService.post<any>('elementosRips', data);
  }
  postInfoPacientes(data: any): Observable<any> {
    return this.httpService.post<any>('informeMedicamentos', data);
  }
  postMipress(data: object): Observable<any> {
    return this.httpService.post<any>('mipress', data);
  }
  postNotifications(data: object): Observable<any> {
    return this.httpService.post<any>('notificationsMed', data);
  }
  postPortalPaciente(data: object): Observable<any> {
    return this.httpService.post<any>('portalpaciente', data);
  }
  postPortalPacienteConvertPDF(data: object): Observable<any> {
    return this.httpService.post<any>('ConvertDocument', data);
  }
  postSearchCities(data: object): Observable<any> {
    return this.httpService.post<any>('cities', data);
  }

  postChatBot(data: object): Observable<any> {
    return this.httpService.post<any>('chatbot', data);
  }

  postCreateUser(data: object): Observable<any> {
    return this.httpService.post<any>('crearUsuario', data);
  }

  postSendCorreoExcel(data: object): Observable<any> {
    return this.httpService.post<any>('SendCorreo', data);
  }

  postPortalEps(data: object): Observable<any> {
    return this.httpService.post<any>('portalEps', data);
  }

  postPortalLab(data: object): Observable<any> {
    return this.httpService.post<any>('portalLab', data);
  }

  postRips(data: object): Observable<any> {
    return this.httpService.post<any>('portalRips', data);
  }

  postVitales(data: object): Observable<any> {
    return this.httpService.post<any>('PortalVitales', data);
  }

  postImportaciones(data: object): Observable<any> {
    return this.httpService.post<any>('importaciones', data);
  }

  postSendCorreoRips(data: object): Observable<any> {
    return this.httpService.post<any>('SendCorreoRips', data);
  }

  postLogistica(data: object): Observable<any> {
    return this.httpService.post<any>('portalLogistico', data);
  }
  postBiib(data: object): Observable<any> {
    return this.httpService.post<any>('generarpdf', data);
  }
  consultarCUM(data: object): Observable<string> {
    return this.httpService.post<any>('imvima', data);
  }
  postinfoDocumentos(data: object): Observable<string> {
    return this.httpService.post<any>('infoDocumentos', data);
  }
  wakeUpPortalAdmin(): Observable<any> {
    return this.httpService.post<any>('portalAdmin', {})
  }

  wakeUpPortal(): Observable<any> {
    return this.httpService.post<any>('portal', {})
  }

  wakeUpMipress(): Observable<any> {
    return this.httpService.post<any>('mipress', {})
  }

  wakeUpexportData(): Observable<any> {
    return this.httpService.post<any>('exportData', {})
  }

  wakeUpGenerarPdf(): Observable<any> {
    return this.httpService.post<any>('generarPdf', {})
  }

  wakePostSearchCities(): Observable<any> {
    return this.httpService.post<any>('cities', {})
  }

  wakePostIntegration(): Observable<any> {
    return this.httpService.post<any>('IntegracionSanitas', {})
  }

  normalizarCodigo(codigo: string): string {
    if (!codigo) return '';
    const [base, sufijo] = codigo.split('-');
    return `${base}-${parseInt(sufijo, 10)}`;
  }
  async getUploadUrl(
    fileName: string,
    contentType: string,
    bucket: string,
  ): Promise<{ uploadUrl: string; fileKey: string }> {
    const body = {
      action: 'GENERAL_URL_S3',
      fileName,
      contentType,
      bucket,
    };

    const response = await firstValueFrom(
      this.httpService.post<{ uploadUrl: string; fileKey: string }>(
        'generarUrl',
        body,
      ),
    );

    return response;
  }
}